export default __webpack_public_path__ + "static/media/cabinet-sink.761f0597.png";